package org.example.site_web.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.ColorInterpolationMethod
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.css.functions.max
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.borderTop
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.topBottom
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.example.site_web.aiPalette
import org.example.site_web.components.images.AccTriangleIcon
import org.example.site_web.components.images.ChevronDown2Icon
import org.example.site_web.content.YourNeedEntry
import org.example.site_web.content.yourNeedsContentMap
import org.example.site_web.toSitePalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text


val YourNeedsContainerBackgroundStyle = CssStyle.base {
    Modifier.backgroundImage(
        linearGradient(
            180.deg,
            ColorInterpolationMethod.SrgbLinear
        ) {
            add(colorMode.toSitePalette().nearBackground, 0.percent)
            add(colorMode.toSitePalette().farBackground, 25.percent)
            add(colorMode.toSitePalette().farBackground, 75.percent)
            add(colorMode.toSitePalette().nearBackground, 100.percent)
        })
//        linearGradient(Colors.Green, Colors.Red,Colors.Green))
}

@Composable
fun YourNeeds() {
    Column(
        YourNeedsContainerBackgroundStyle.toModifier()
            .margin(top = 2.em)
            .fillMaxWidth()
            .padding(bottom = 4.em), horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Row(
            Modifier.width(min(70.vw, 1344.px))
                .fontSize(1.8.cssRem)
                .fontWeight(FontWeight.SemiBold)
                .padding {
                    topBottom(1.em)
                }, horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.Bottom
        ) {

            Span() {
                AccTriangleIcon()
                Text("Votre besoin")
            }
        }
        Box(Modifier.width(min(70.vw, 1344.px))) {
            YourNeedsContentLargeLayout(modifier = Modifier.displayIfAtLeast(Breakpoint.LG))
            YourNeedsContentThinLayout(modifier = Modifier.displayUntil(Breakpoint.LG))
        }
    }
}


@Composable
fun YourNeedsContentLargeLayout(modifier: Modifier = Modifier) {
    val entrySelected = mutableStateOf<String>(yourNeedsContentMap.firstNotNullOf { entry -> entry.key })
    Column(modifier.fillMaxWidth()) {
        Row(Modifier.fillMaxWidth()) {
            for (entry in yourNeedsContentMap) {
                val isSelected = entrySelected.value == entry.key
                YourNeedButton(
                    modifier = Modifier.margin(leftRight = 1.em),
                    entry = entry.value,
                    isSelected = isSelected,
                    onClick = {
                            entrySelected.value = entry.key
                    })
            }
        }
        Row(
            Modifier.fillMaxWidth()
                .margin(top = 0.25.cssRem,
                    bottom = 1.5.cssRem,
                    left = 1.cssRem)
                .padding(top = 1.cssRem, bottom = 1.cssRem)
                .borderTop{
                    style(LineStyle.Solid)
                    color(aiPalette.mainPalette.darker)
                    width(2.px)
                }
                .borderBottom{
                    style(LineStyle.Solid)
                    color(aiPalette.mainPalette.darker)
                    width(2.px)
                },
            verticalAlignment = Alignment.Top
        )
        {
            YourNeedsDescription(yourNeedsContentMap.get(entrySelected.value)?.description ?: "",
                modifier = Modifier
                    .height(12.cssRem)
                    .padding(leftRight = 2.em)
                    .width(60.percent))
            YourNeedImage(entrySelected.value, modifier = Modifier
                .height(12.cssRem)
                .width(40.percent))
        }
    }
}


@Composable
fun YourNeedsContentThinLayout(modifier: Modifier = Modifier) {
    val entrySelected = mutableStateOf<String?>(null)
    Column(modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally) {
        for (entry in yourNeedsContentMap) {
            val isSelected = entrySelected.value == entry.key
            YourNeedButton(
                modifier = Modifier
                    .width(max(50.vh,20.cssRem))
                    .margin(leftRight = 1.em, topBottom = 0.25.em),
                entry = entry.value,
                isSelected = isSelected,
                onClick = {
                    if(entrySelected.value == entry.key) {
                        entrySelected.value = null
                    }
                    else{
                        entrySelected.value = entry.key
                    }
                })
            if (isSelected) {
                Column(Modifier
                    .margin(top = 0.25.cssRem, bottom = 1.5.cssRem)
                    .padding(top = 0.5.cssRem, bottom = 0.5.cssRem)
                    .borderTop{
                        style(LineStyle.Solid)
                        color(aiPalette.mainPalette.darker)
                        width(2.px)
                    }
                    .borderBottom{
                        style(LineStyle.Solid)
                        color(aiPalette.mainPalette.darker)
                        width(2.px)
                    }) {
                    YourNeedsDescription(
                        yourNeedsContentMap.get(entrySelected.value)?.description ?: "NULL",
                        modifier = Modifier.width(100.percent)
                    )
                    YourNeedImage(
                        entrySelected.value ?: "NULL",
                        modifier = Modifier.margin(top = 1.cssRem).width(100.percent)
                    )
                }
            }
        }
    }
}



@Composable
fun YourNeedsDescription(entry: String,modifier: Modifier=Modifier) {
    Box(
        modifier = modifier
            .fontSize(0.8.cssRem)
            .fontWeight(FontWeight.Normal),
        contentAlignment = Alignment.TopCenter
//.backgroundColor(Colors.Red)
    )
    {
        Span(
            Modifier
                .textAlign(TextAlign.Justify)
                .whiteSpace(WhiteSpace.PreWrap).toAttrs()
        ) {
            Text(entry)
        }
    }
}

@Composable
fun YourNeedButton(
    modifier: Modifier = Modifier,
    entry: YourNeedEntry,
    isSelected: Boolean,
    onClick: () -> Unit
) {
    val borderColor = if (isSelected) {
        aiPalette.mainPalette.darker
    } else {
        aiPalette.mainPalette.darkest
    }
    Column(modifier = modifier)
    {
        Button(
            onClick = { evt ->
                evt.preventDefault()
                onClick()
            },
            modifier = Modifier
                .border {
                    color(borderColor)
                    style(LineStyle.Solid)
                    width(2.px)
                }
                .fontSize(0.85.em)
                .fillMaxWidth()
                .height(4.0.cssRem)
                .padding(topBottom = 0.em, leftRight = 2.em),
        ) {
            Column(
                Modifier.fillMaxHeight(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.SpaceAround
            ) {
                Span() { Text(entry.title) }
            }
        }
        if (isSelected) {
            Box(Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                ChevronDown2Icon(
                    Modifier
                        .width(4.em)
                        .height(2.em)
                        .styleModifier {
                            color(borderColor)
                        })
            }
        }
    }
}

@Composable
fun YourNeedImage(fileName: String, modifier: Modifier = Modifier) {
    Div(
        modifier
            .borderRadius(6.px)
            .fillMaxHeight()
            .toAttrs()
    ) {
        Img(
            src = "assets/pics/yourneeds/${fileName}.jpg",
            attrs = Modifier
                .width(100.percent)
                .height(100.percent)
                .objectFit(ObjectFit.Contain).toAttrs()
        )
    }
}


//@Composable
//fun YourNeedsText(selectedEntryState: MutableState<String>) {
//
//    Column(Modifier.maxWidth(max(40.vw,720.px)),
//        verticalArrangement = Arrangement.Top,
//        horizontalAlignment = Alignment.CenterHorizontally) {
//        Row(Modifier.fillMaxWidth(),
//            horizontalArrangement = Arrangement.SpaceAround,
//            verticalAlignment = Alignment.Top) {
//            var i = 0
//            for (entry in yourNeedsContentMap.entries) {
//                val isSelected = entry.key == selectedEntryState.value
//                Column(
//                    Modifier
//                        .padding(right = 1.em)
//                ) {
//
//                    if (isSelected) {
//                        Box(Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
//                            ChevronDown2Icon(Modifier
//                                .width(4.em)
//                                .height(2.em)
//                                .styleModifier {
//                                    color(borderColor)
//                                })
//                        }
//                    }
//                }
//                i += 1
//            }
//        }
//
//    }
//}
